export type { AccountMenuItem, AccountMenuProps } from './AccountMenu';
export { AccountMenu } from './AccountMenu';
export type { BannerInboxAction, BannerInboxItem, BannerInboxProps } from './BannerInbox';
export { BannerInbox, BannerInboxBellIcon } from './BannerInbox';
export { HeaderActions } from './HeaderActions';
export type { HeaderIconButtonProps } from './HeaderIconButton';
export { HeaderIconButton } from './HeaderIconButton';
export type { HeaderIconLinkProps } from './HeaderIconLink';
export { HeaderIconLink } from './HeaderIconLink';
export { HeaderLogo } from './HeaderLogo';
export type { HeaderNavLinkProps } from './HeaderNavLink';
export { HeaderNavLink } from './HeaderNavLink';
export { HeaderSeparator } from './HeaderSeparator';
export type {
  SiteHeaderAccountMenu,
  SiteHeaderBannerInbox,
  SiteHeaderLogin,
  SiteHeaderProps,
  SiteHeaderUser,
  SiteHeaderWatchLive,
} from './SiteHeader';
export { SiteHeader } from './SiteHeader';

import type { ReactNode } from 'react';
import { cn } from '../utils';

export interface HeaderProps {
  children: ReactNode;
  className?: string;
}

export function Header({ children, className }: HeaderProps) {
  return (
    <header
      className={cn(
        'sticky top-0 z-30 flex w-full items-center justify-center text-white',
        'bg-header',
        'h-header sm:h-header-wide',
        className,
      )}
    >
      <div className="flex w-full max-w-[1170px] items-center justify-between gap-4 px-5">{children}</div>
    </header>
  );
}
